import React, { useState } from 'react';
import OverviewTable from 'components/Table/Table';
import { TableColumnInterface } from 'components/Table/table.types';
import { User, UserGroup } from '@restore/services-lib';
import { useUsersContext } from 'context/users.context';
import UpdateUser from 'pages/Users/UpdateUser';
import Switch from '@mui/material/Switch';
import { Tag } from 'components/Tag/Tag';
import UsersFilter from 'pages/Users/Table/Filters';
import { hasPermissions } from 'config/ability';
import { useAuthContext } from 'context/auth.context';
import TagTableCellContainer from 'components/Tag/TagHelpers/TagTableCellContainer';

const UsersTable = (): JSX.Element => {
  const { users, toggleUserActive } = useUsersContext();
  const [loading, setLoading] = useState<{ [key: number]: boolean }>({});
  const { ability } = useAuthContext();

  const getUserGroupDisplay = (userGroups: UserGroup[]) =>
    userGroups.map((userGroup) => `${userGroup.name}`).join(', ');

  const flipTheSwitch = async (user: User) => {
    setLoading({ [user.id]: true });
    await toggleUserActive(user.id);
    setLoading({ [user.id]: false });
  };

  const tableCols: TableColumnInterface<User>[] = [
    { label: 'Name', value: (user) => `${user.firstName} ${user.lastName}`, sortBy: 'firstName' },
    { label: 'Email', value: (user) => user.email, sortBy: 'email' },
    { label: 'User Groups', value: (user) => getUserGroupDisplay(user.userGroups) },
    {
      label: 'Tags',
      value: (user) => (
        <TagTableCellContainer>
          {user.tags.map((tag) => (
            <Tag key={tag.id} color={tag.displayColour} text={tag.name} />
          ))}
        </TagTableCellContainer>
      ),
    },
    {
      label: 'Active',
      value: (user) => (
        <>
          {hasPermissions(ability, 'delete', 'User') ? (
            <Switch
              checked={user.isActive}
              onChange={() => flipTheSwitch(user)}
              disabled={loading[user.id]}
            />
          ) : (
            <Switch checked={user.isActive} sx={{ cursor: 'default' }} disabled={true} />
          )}
        </>
      ),
      sortBy: 'isActive',
    },
    {
      label: '',
      align: 'right',
      value: (user) => <UpdateUser user={user} />,
    },
  ];

  return (
    <>
      <UsersFilter />
      <OverviewTable data={users} columns={tableCols} />
    </>
  );
};

export default UsersTable;
